const COLORS = ["#FF001E", "#F4C84D", "#19945D"];

export default function DecileCircles({ decil }) {
  const colorIndex = Math.min(Math.floor((10 - decil) / 3), 2);
  const color = COLORS[colorIndex];
  const filled = 10 - decil;

  return (
    <div className="decile-circles">
      {[0, 1, 2, 3, 4].map((i) => {
        const leftHalf = filled - 1 < i * 2 ? "#CCC" : color;
        const rightHalf = filled < i * 2 ? "#CCC" : color;
        return (
          <svg key={i} className="scale-circle" viewBox="0 0 72 72" width="20" height="20">
            <circle cx="36" cy="36" r="36" fill={leftHalf} />
            <path d="M36,72C16.12,72,0,55.88,0,36S16.12,0,36,0v72Z" fill={rightHalf} />
          </svg>
        );
      })}
    </div>
  );
}
